export default __webpack_public_path__ + "static/media/qr-code.c5a93fac.png";